import { useTranslation } from "react-i18next";
import { Modifydetail } from "../../../../../../redux/apiSpecifications/apiCrud";
import React, { useMemo } from "react";
import { dateToDisplayDate } from "../../../../../../utils/date";

interface IPracticeModifiedDescriptionProps {
  modifyDetailsJson: Modifydetail[];
}

type MapEntry = {
  entity: string;
  field: string;
  oldValue: string;
  newValue: string;
};

const PracticeModifiedDescription = ({
  modifyDetailsJson,
}: IPracticeModifiedDescriptionProps) => {
  const { t } = useTranslation();

  const isDateField = (field: string) => 
    ["expiration_date_client", "expiration_date_sla"].includes(field);

const translateValue = (field: string, value: string) => {
    if (value === "[NULL]") {
        return t("historical-actions-field-null-value");
    } 
    
    if (isDateField(field)) {
        return ["", "01/01/0001"].includes(value)
            ? t("historical-actions-date-field-no-value")
            : dateToDisplayDate(value);
    }

    switch (field) {
        case "practice_type_code":
            return t(`appraisals-details-tab-details-appraisals-expertise-type-${value}`);
        case "claims_branch_code":
            return t(`claims_branch_code-${value}`);
        case "signature_type":
            return t(`select-signature-type-${value}`);
        case "status":
            return t(`appraisal-statuses-${value}`);
        case "urgency_reason":
            return t(`urgency_reason-${value}`);
        default:
            return value;
    }
};


  const getDescription: string[] = useMemo(() => {
    let descriptions: string[] = [];

    let map = new Map();

    modifyDetailsJson.forEach((element) => {
      const splitOldNew = element.key!.split("-");

      const splitEntity = splitOldNew[0].split(".");

      let mapEntry: MapEntry;

      if (map.has(splitOldNew[0])) {
        mapEntry = map.get(splitOldNew[0]);
      } else {
        mapEntry = {
          entity: splitEntity[0].includes("owner")
            ? "owner"
            : splitEntity[0].includes("communication_recipient")
            ? "communication_recipient"
            : splitEntity[0].includes("appraisal_location")
            ? "appraisal_location"
            : "", // splitEntity.length === 2 ? splitEntity[0] : "",

          field: splitEntity.length === 2 ? splitEntity[1] : splitEntity[0],
          oldValue: "",
          newValue: "",
        };

        map.set(splitOldNew[0], mapEntry);
      }

      if (splitOldNew[1] === "old") {
        mapEntry!.oldValue = element.value!;
      } else {
        mapEntry!.newValue = element.value!;
      }
    });

    map.forEach((value: MapEntry, key) => {
      const fieldTranslation = t(`historical-actions-field-${value.field}`);

      const entityTranslation = t(
        value.entity === "" ? "" : `historical-actions-entity-${value.entity}`
      );

      let dictionaryKey = "";

      if (["True", "False"].includes(value.newValue)) {
        dictionaryKey =
          value.entity === ""
            ? `historical-actions-practice-modified-description-flag-${value.newValue}`
            : `historical-actions-practice-modified-description-entity-flag-${value.newValue}`;
      } else {
        dictionaryKey =
          value.entity === ""
            ? `historical-actions-practice-modified-description`
            : `historical-actions-practice-modified-description-entity`;
      }

      descriptions.push(
        t(dictionaryKey, {
          field_name: fieldTranslation,
          entity_name: entityTranslation,
          old_value: translateValue(value.field, value.oldValue),
          new_value: translateValue(value.field, value.newValue),
        })
      );
    });

    return descriptions;
  }, [modifyDetailsJson]);

  return (
    <>
      {getDescription.map((description, index) => (
        <React.Fragment key={index}>
          {description}
          <br />
        </React.Fragment>
      ))}
    </>
  );
};

export default PracticeModifiedDescription;
